import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4" data-testid="not-found-page">
      <p className="font-mono text-[10px] font-bold uppercase tracking-[0.35em] text-[#00E5FF]">Signal lost</p>
      <h1 className="font-heading font-black text-white text-5xl sm:text-6xl mt-3">404</h1>
      <p className="text-gray-400 text-base mt-3 max-w-md">
        This page doesn't exist in the intelligence base — it may have moved or never shipped.
      </p>
      <Link to="/" data-testid="not-found-home-link"
        className="group inline-flex items-center gap-2 mt-8 rounded-full border border-white/[0.14] bg-white/[0.05] px-5 py-2.5 font-mono text-[12px] font-bold text-white hover:border-[#00E5FF]/50 transition-colors">
        <ArrowLeft className="h-3.5 w-3.5 transition-transform duration-200 group-hover:-translate-x-0.5" />
        Back to NewsLayer
      </Link>
    </div>
  );
}
